export function calculateDailyNutrition(entries, recipes, dailyIntake) {
  if (!entries || !Array.isArray(entries) || !recipes || !Array.isArray(recipes) || !dailyIntake) {
    return null;
  }

  let totalKcal = 0;
  let totalProtein = 0;

  entries.forEach((entry) => {
    // TODO: This code is piece of shit, it handles different data structures for meal logs and meal plans in dirty way.
    // Also the ingredients.reduce is duplicated in the codebase. Refactor this!
    if (entry.ingredients && entry.ingredients.length > 0) {
      const nutrients = entry.ingredients.reduce((acc, ingredient) => {
        return {
          kcal: acc.kcal + ingredient.nutrients.kcal,
          protein: acc.protein + ingredient.nutrients.protein,
          fat: acc.fat + ingredient.nutrients.fat,
          carbs: acc.carbs + ingredient.nutrients.carbs,
        };
      }, { kcal: 0, protein: 0, fat: 0, carbs: 0 });
      totalKcal += nutrients.kcal;
      totalProtein += nutrients.protein;      
      return
    }

    const recipe = recipes.find((r) => r.id === entry.recipe_id);
    if (!recipe || !recipe.personalizedNutrition || !recipe.personalizedNutrition.perServing) return;

    const { perServing } = recipe.personalizedNutrition;
    
    totalKcal += perServing.kcal;
    totalProtein += perServing.protein;
  });

  const caloriesPercentage = dailyIntake.kcal > 0 ? (totalKcal / dailyIntake.kcal) * 100 : 0;
  const proteinPercentage = dailyIntake.protein > 0 ? (totalProtein / dailyIntake.protein) * 100 : 0;

  if (caloriesPercentage === 0 && proteinPercentage === 0) {
    return null;
  }

  return {
    kcal: Math.round(totalKcal),
    protein: Math.round(totalProtein * 10) / 10,
    caloriesPercentage,
    proteinPercentage,    
  };
}

